import { render, staticRenderFns } from "./ChangeEmailForm.vue?vue&type=template&id=0bc3dede&"
import script from "./ChangeEmailForm.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc3dede')) {
      api.createRecord('0bc3dede', component.options)
    } else {
      api.reload('0bc3dede', component.options)
    }
    module.hot.accept("./ChangeEmailForm.vue?vue&type=template&id=0bc3dede&", function () {
      api.rerender('0bc3dede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/ChangeEmailForm.vue"
export default component.exports